var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#1CC3ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3964 13.9629C12.3047 13.9537 12.1947 13.9537 12.0939 13.9629C9.91219 13.8895 8.17969 12.102 8.17969 9.90203C8.17969 7.6562 9.99469 5.83203 12.2497 5.83203C14.4955 5.83203 16.3197 7.6562 16.3197 9.90203C16.3105 12.102 14.578 13.8895 12.3964 13.9629Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.041 7.66797C20.8194 7.66797 22.2494 9.10714 22.2494 10.8763C22.2494 12.6088 20.8744 14.0205 19.1602 14.0846C19.0869 14.0755 19.0044 14.0755 18.9219 14.0846",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81414 17.348C5.59581 18.833 5.59581 21.253 7.81414 22.7288C10.335 24.4155 14.4691 24.4155 16.99 22.7288C19.2083 21.2438 19.2083 18.8238 16.99 17.348C14.4783 15.6705 10.3441 15.6705 7.81414 17.348Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 22.332C21.4725 22.1945 22.0958 21.9287 22.6092 21.5345C24.0392 20.462 24.0392 18.6929 22.6092 17.6204C22.105 17.2354 21.4908 16.9787 20.84 16.832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1f29b2bc74aa74b7b09acd550c15be53.svg";
export { ForwardRef as ReactComponent };